import { atomWithStorage } from 'jotai/utils'
import { useAtom } from 'jotai'
import { AtomKey, Language } from 'lib/types'
import { storage } from './config'

const languageAtom = atomWithStorage(AtomKey.Language, Language.EN, storage)

export const useLanguageAtom = () => useAtom(languageAtom)
